
export interface IDateOrdinal {
  day_ordinal_display_name: string;
  day: number;
}

